const ProcessTypes = {
  Posting: "posting",
  Normal: "normal",
  Grid: "grid",
  Cycle: "cycle",
};
const RowTypes = {
  NavHeader: "navHeader",
  NavProperty: "navProperty",
  Blank: "blank",
  RowGroup: "rowGroup",
  PlayerAttribute: "playerAttribute",
  Player: "player",
  Sign: "sign",
  Activity: "activity",
  Grid: "grid",
};

const ColumnTypes = {
  NavHeader: "navHeader",
  NavProperty: "navProperty",
  Blank: "blank",
  Flow: "flow",
  ColumnGroup: "columnGroup",
  Activity: "activity",
  TrackType: "trackType",
  Player: "player",
  Grid: "grid",
};

const defaultRows = [
  { id: "Header", type: RowTypes.NavHeader },
  { id: "Show", type: RowTypes.NavProperty },
  { id: "Size", type: RowTypes.NavProperty },
  { id: "Blank", type: RowTypes.Blank },
  { id: "RowGroup", type: RowTypes.RowGroup },
  { id: "Attribute", type: RowTypes.PlayerAttribute },
  { id: "Player", type: RowTypes.Player },
];

const defaultColumns = [
  { id: "Header", type: ColumnTypes.NavHeader },
  { id: "Show", type: ColumnTypes.NavProperty },
  { id: "Size", type: ColumnTypes.NavProperty },
  { id: "Blank", type: ColumnTypes.Blank },
  { id: "Flow", type: ColumnTypes.Flow },
  { id: "ColumnGroup", type: ColumnTypes.ColumnGroup },
  { id: "Activity", type: ColumnTypes.Activity },
];

const defaultCells = {
  Header: { Show: "Show", Size: "Size" },
  Show: { Show: "Show" },
  Size: { Size: "Size" },
  Blank: {},
  RowGroup: { Activity: "R/G" },
  Attribute: { Activity: "Object Type" },
  Player: { Flow: "Action Flow", ColumnGroup: "C/G", Activity: "Activity" },
};
const defaultPostingCells = {
  Header: { Show: "Show", Size: "Size" },
  Show: { Show: "Show" },
  Size: { Size: "Size" },
  Blank: {},
  RowGroup: { TrackType: "R/G" },
  Attribute: { TrackType: "Object Type" },
  Player: { TrackType: "Player" },
  Sign: { Flow: "Action Flow", ColumnGroup: "C/G", Activity: "G/L Account", TrackType: "Track Type" },
};

module.exports = {
  ProcessTypes,
  RowTypes,
  ColumnTypes,
  defaultRows,
  defaultColumns,
  defaultCells,
  defaultPostingCells,
  defaultPostingRows: [
    ...defaultRows,
    {
      id: "Sign",
      type: RowTypes.Sign,
    },
  ],
  defaultPostingColumns: [
    ...defaultColumns,
    {
      id: "TrackType",
      type: ColumnTypes.TrackType,
    },
  ],
  defaultGridRows: 16000,
  defaultGridColumns: 1000,
};
